export const formatter = new Intl.NumberFormat("pt-br", {
  style: "currency",
  currency: "BRL",
});
